import React, { ReactElement } from 'react';

import LoadingBar from 'react-redux-loading-bar'

export const Header = (): ReactElement => (
  <header>
    <LoadingBar style={{ backgroundColor: '--pink' }} />
  </header>
)
